import {Bundle as ClareBundle, DisplayMetadata, Image} from '@sportngin/se-commerce-sdk/models/clare';

/**
 * Bundle display metadata used by create/update.
 */
export interface BundleDisplayMetadata {
  fulfilled_by?: string;
  images?: Image[];
}

/**
 * POST /finance/bundles
 */
export interface CreateBundleRequest {
  catalog_ids: number[];
  name: string;
  description?: string;
  price_cents: number;
  active: boolean;
  image_url?: string;
  display_metadata?: BundleDisplayMetadata;
  products?: BundleProductsUpdateProduct[];
}

export type BundleCreateRequestInterface = CreateBundleRequest;

export type Bundle = ClareBundle;

export interface BundleSummary {
  id: number;
  name: string;
  description: string | null;
  price_cents: number;
  active: boolean;
  image_url: string | null;
  store_id: number;
  catalog_ids: number[];
  display_metadata: DisplayMetadata | null;
}

/**
 * PATCH|PUT /finance/bundles/:id
 */
export interface UpdateBundleRequest {
  name?: string;
  description?: string;
  price_cents?: number;
  active?: boolean;
  image_url?: string | null;
  display_metadata?: BundleDisplayMetadata | null;
}

export interface BundleProductsUpdateProduct {
  product_id: number;
  price_cents?: number;
}

export type BundleProductPayloadInterface = BundleProductsUpdateProduct;

export interface BundleProductsUpdateRequest {
  products: BundleProductsUpdateProduct[];
}

export type BundleProductsUpdateRequestInterface = BundleProductsUpdateRequest;

/**
 * List endpoints only need bundle summary data. Clearing nested products keeps
 * NgRx/DevTools payloads shallow and avoids stack overflows from recursive API payloads.
 */
export function stripBundleProducts(bundle: Bundle): Bundle {
  return {
    ...bundle,
    products: [],
  };
}

export function stripBundleProductsFromList(bundles: Bundle[]): Bundle[] {
  return bundles.map(stripBundleProducts);
}
